export const PROJECT_BRANDS = Object.freeze({
  reverse: 'ReverseHealth',
  muscleCharge: 'MuscleCharge',
});
